import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../components/SectionTitle";
import brandLogo from "../../pages/home/components/img/brands/Logo_Imperial_bamboo.png"; 
import phoneImage from "../../pages/home/components/img/brands/Bamboo-phone-mockup.png";
import metric1 from "../../pages/home/components/img/brands/bamboo-metric1.png";
import metric2 from "../../pages/home/components/img/brands/bamboo-metric2.png";
import metric3 from "../../pages/home/components/img/brands/bamboo-metric3.png";
import menu1 from "../../pages/home/components/img/brands/bamboo-menu-1.png";
import menu2 from "../../pages/home/components/img/brands/bamboo-menu-2.png";
import menu3 from "../../pages/home/components/img/brands/bamboo-menu-3.png";
import deliveryPartners from "../../pages/home/components/img/brands/delivery-partners.png";
import ctaImage from "../../pages/home/components/img/brands/bamboo-cta-image.png";
import otherBrand1 from "../../pages/home/components/img/brands/brand-1.png";
import otherBrand2 from "../../pages/home/components/img/brands/brand-3.png";
import otherBrand3 from "../../pages/home/components/img/brands/brand-6.png";
import "./TheImperialBamboo.scss";
import videoFile from "../../pages/home/components/videos/TheImperialBambooVideo.mp4"; // ✅ Correctly placed import

const ImperialBamboo = () => {
	return (
	  <div className="imperial-bamboo-page">
		
	   {/* Hero Section */}
	   <section className="hero-section">
		  <div className="container text-center">
			<img src={brandLogo} alt="Bamboo Logo" className="brand-logo" />
			<h1>Bring The Imperial Bamboo to your area</h1>
  
			{/* Video Section */}
			<div className="video-container">
			  <video className="hero-video" controls>
				<source src={videoFile} type="video/mp4" />
				Your browser does not support the video tag.
			  </video>
			</div>
  
			
		  </div>
		</section>
   
  
	   {/* Business Value Proposition Section */}
  <section className="business-section">
	<div className="container">
	  <div className="business-content">
		<img src={phoneImage} alt="Order Just Chicken Wings" className="phone-mockup" />
		<div className="business-text">
		  <h2>Enhance Your Taste for Authentic Chinese Cuisine</h2>
		  <p>
		  The Imperial Bamboo offers authentic, flavorful Chinese cuisine with a modern twist. From sizzling stir-fries to rich, savory broths, our menu brings the essence of traditional Chinese cooking straight to your customers.
		  </p>
		</div>
	  </div>
	</div>
  </section>
  
  
		{/* Key Metrics / Achievements Section */}
		<section className="metrics-section">
		  <div className="container text-center">
			<div className="metrics">
			  <img src={metric1} alt="Sales" />
			  <p>Expand Your Menu, Boost Your Profits</p>
			</div>
			<div className="metrics">
			  <img src={metric2} alt="Customers" />
			  <p>Authentic Chinese Cuisine</p>
			</div>
			<div className="metrics">
			  <img src={metric3} alt="Years in Business" />
			  <p>Join a Thriving Virtual Brand with Zero Risk</p>
			</div>
		  </div>
		</section>
  
		{/* Testimonial Section */}
		<section className="testimonial-section">
		  <div className="container text-center">
			<blockquote>
			"Adding The Imperial Bamboo to my restaurant was the best decision! Customers love the rich, authentic flavors, and it has become a favorite on our menu."
			</blockquote>
			<cite>— Michael, Local Restaurant Owner</cite>
		  </div>
		</section>
  
		{/* Popular Menu Items / Featured Dishes Section */}
		<section className="menu-section">
		  <div className="container">
			<h2>Fan Favorites</h2>
			<div className="menu-items">
			  <div className="menu-card">
				<img src={menu1} alt="Buffalo Wings" />
				<h3>Crispy General Tso Chicken</h3>
				<p>Crispy, golden-fried chicken tossed in a sweet, tangy, and slightly spicy sauce, delivering the perfect balance of crunch and flavor.</p>
			  </div>
			  <div className="menu-card">
				<img src={menu2} alt="Garlic Parmesan Wings" />
				<h3>Pan-Seared Dumplings</h3>
				<p>Juicy, flavorful dumplings stuffed with seasoned chicken and vegetables, seared to perfection for a crispy golden crust.</p>
			  </div>
			  <div className="menu-card">
				<img src={menu3} alt="BBQ Wings" />
				<h3>Crispy Golden Egg Rolls</h3>
				<p>Crunchy on the outside, packed with savory cabbage, carrots, and seasoned chicken, and served with a side of tangy dipping sauce. </p>
			  </div>
			</div>
		  </div>
		</section>
  
	 {/* Delivery Platforms Section */}
  <section className="delivery-section">
	<div className="container">
	  <div className="text-content">
		<h2>Available on Hey Jag Customer App</h2>
		<p>
		  The Imperial Bamboo is available exclusively on <strong>Hey Jag customer App</strong>, 
		  the revolutionary delivery platform that offers lower fees, better service, 
		  and direct support for restaurants. Customers can easily order their favorite 
		  wings with faster delivery and seamless tracking.
		</p>
		<Link to="/delivery" className="cmn-btn">
			<span>Learn More</span></Link>
	  </div>
	  <div className="delivery-logos">
		<img src={deliveryPartners} alt="Delivery Partners on Hey Jag" />
		
	  </div>
	</div>
  </section>
  
  
  
	   {/* Call-to-Action (CTA) Section */}
  <section className="cta-section">
	<div className="container text-center">
	  <h2>That’s a Wrap!</h2>
	  <p>Start running The Imperial Bamboo from your kitchen today.</p>
	  <img src={ctaImage} alt="Join Now" className="cta-image" />  {/* Image with reduced size ✅ */}
	  <a
		href="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3bx6kbQqtu-wVjgCL2H26Z16mSbWqgSAt5J-bVWbFdx6o_jy0Knt21nnGAvFeQfaJpx7LtZld7?gv=true"
		target="_blank"
		rel="noopener noreferrer"
		className="cmn-btn"
	  >
		<span>Take The First Step</span>
	  </a>
	</div>
  </section>
  
  
		{/* Explore Other Brands Section */}
		<section className="other-brands-section">
		  <div className="container">
			<h2>Not your flavor? Explore other brands:</h2>
			<div className="other-brands">
			  <div className="brand-card">
				<img src={otherBrand1} alt="Brand 1" />
				<h3>Just Chicken Wings</h3>
				<Link to="/brands/just-chicken-wings" className="cmn-btn">
				<span>LEARN MORE</span></Link>
			  </div>
			  <div className="brand-card">
                  <img src={otherBrand2} alt="Brand 1" />
                  <h3>BFF Burgers</h3>
                  <Link to="/brands/bff" className="cmn-btn">
                  <span>LEARN MORE</span></Link>
                </div>
			  <div className="brand-card">
				<img src={otherBrand3} alt="Brand 3" />
				<h3>NYPD Pizza</h3>
				<Link to="/brands/nypd-pizza" className="cmn-btn">
				<span>LEARN MORE</span></Link>
			  </div>
			</div>
		  </div>
		</section>
  
	  </div>
	);
  };

export default ImperialBamboo;
